// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { tabClasses } from '@mui/material/Tab';
import { rem } from '../../tokens/conversions';
import { tabColors } from './tabColors';
// Shared with AppBar, whose condensed variant shrinks the tabs it contains.
export var condensedTabStyle = {
    padding: "".concat(rem(8), " ").concat(rem(12)),
    fontSize: rem(12),
    lineHeight: rem(16),
    minHeight: rem(32),
    maxHeight: rem(32),
    gap: rem(4)
};
export var Tab = function(mode) {
    var c = tabColors(mode);
    var _obj;
    var override = {
        MuiTab: {
            styleOverrides: {
                root: (_obj = {
                    color: c.text,
                    textTransform: 'none',
                    opacity: 1,
                    padding: "".concat(rem(12), " ").concat(rem(16)),
                    fontSize: rem(14),
                    lineHeight: rem(18),
                    fontWeight: 500,
                    minWidth: rem(44),
                    minHeight: rem(44),
                    maxHeight: rem(44),
                    gap: rem(8)
                }, _define_property(_obj, "& .".concat(tabClasses.iconWrapper), {
                    color: c.icon,
                    margin: 0
                }), _define_property(_obj, '&&&:hover', _define_property({
                    backgroundColor: c.hover.background
                }, "& .".concat(tabClasses.iconWrapper), {
                    color: c.hover.icon,
                    margin: 0
                })), _define_property(_obj, "&.".concat(tabClasses.disabled), _define_property({
                    color: c.disabled.text,
                    opacity: 1
                }, "& .".concat(tabClasses.iconWrapper), {
                    color: c.disabled.icon,
                    margin: 0
                })), _define_property(_obj, "&.".concat(tabClasses.selected), _define_property({
                    color: c.text
                }, "& .".concat(tabClasses.iconWrapper), {
                    color: c.selected.icon,
                    margin: 0
                })), _define_property(_obj, "&.".concat(tabClasses.labelIcon), {
                    minHeight: 'unset'
                }), _obj)
            },
            variants: [
                {
                    props: {
                        condensed: true
                    },
                    style: condensedTabStyle
                }
            ],
            defaultProps: {
                disableTouchRipple: true,
                iconPosition: 'start'
            }
        }
    };
    return override;
};

//# sourceMappingURL=Tab.js.map